import clone from 'lodash/clone';
import set from 'lodash/set';
import setWith from 'lodash/setWith';
import type { ErrorResponse } from '@atlassian/jira-servicedesk-common/src/utils/fetch';
import { ERROR_STATE_REVERT_PATH } from '../../../../common/constants';
import type { Group } from '../../../../common/types';
import { GROUPS_DATA_PATH } from '../../constants';
import { getGroupsSelector } from '../../selectors';
import type { ImmutableState, State } from '../../types';

// Create new object from immutable object
export const setGroupsMutator = (groups: Group[], state: ImmutableState): State =>
	setWith(clone(state), GROUPS_DATA_PATH, groups, clone);

export const removeGroupMutator = (groupId: number, state: ImmutableState): State => {
	const groups = getGroupsSelector(state);
	const newGroups = groups.filter(({ id }) => id !== groupId);
	return setGroupsMutator(newGroups, state);
};

export const addGroupMutator = (group: Group, state: ImmutableState): State => {
	const oldGroups = getGroupsSelector(state);
	return setGroupsMutator([...oldGroups, group], state);
};

export const updateTicketTypesByGroupMutator = (
	groupId: number,
	ticketTypeIds: number[],
	state: ImmutableState,
): State => setWith(clone(state), `ticketTypesByGroup[${groupId}]`, ticketTypeIds, clone);

export const updateGroupsByTicketTypeMutator = (
	ticketTypeId: number,
	groupIds: number[],
	state: ImmutableState,
): State => setWith(clone(state), `groupsByTicketType[${ticketTypeId}]`, groupIds, clone);

export const updateGroupMutator = (updatedGroup: Group, state: ImmutableState): State => {
	const groups = getGroupsSelector(state).slice();
	const updatedGroupIndex = groups.findIndex(({ id }) => id === updatedGroup.id);
	if (updatedGroupIndex >= 0) {
		groups[updatedGroupIndex] = updatedGroup;
	}

	return setGroupsMutator(groups, state);
};

export const addRevertFlagToErrorResponse = (error: ErrorResponse, stateReverted: boolean) =>
	set(error, ERROR_STATE_REVERT_PATH, stateReverted);

export const reorderGroupsMutator = (from: number, to: number, state: ImmutableState): State => {
	const groups = getGroupsSelector(state).slice();
	const group = groups.splice(from, 1)[0];
	group && groups.splice(to, 0, group);

	return setGroupsMutator(groups, state);
};
